import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "underscore";
import hallImg from "../../assets/images/resume.png";
import { getCategoryList } from "../../store/shopping/shopping.selector";
import { fetchLiveStreamRequest } from "../../store/social/social.actions";
import { getLiveStreams } from "../../store/social/social.selector";
import { getUserPrivateLounge } from "../../store/user/privatelounge/privatelounge.selector";
import {
    getImage,
    getOtherUserProfile,
    getUserProfile,
} from "../../store/user/user.selector";
import {
    Avatar,
    Button,
    Box,
    Container,
    Grid,
    makeStyles,
    Paper,
    Tab,
    Tabs,
    Typography,
    CardContent,
    CardActions,
    Card,
    Divider,
    ListItem,
    ListItemText,
    List,
    Modal,
    CardMedia,
    ListItemAvatar,
    Chip,
} from "@material-ui/core";
import LiveStreamCard from "../Profile/liveStreamCard";
import { IsNullOrEmpty } from "../../helpers/utility";
import { Alert } from "@material-ui/lab";
import { fetchPaymentConfigRequest } from "../../store/shopping/shopping.actions";
import { RadioButtonChecked, RadioButtonUnchecked } from "@material-ui/icons";

const PrivateLounge = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [period, setPeriod] = useState("");

    const { userProfile, categories, allLiveStreams, userPrivateLounge } =
        useSelector((state) => {
            return {
                userProfile: getOtherUserProfile(state),
                categories: getCategoryList(state),
                allLiveStreams: getLiveStreams(state),
                userPrivateLounge: getUserPrivateLounge(state),
            };
        });

    useEffect(() => {
        if (categories.length > 0 && userProfile.id) {
            const cat = _.find(categories, (x) => x.name === "Private Hall");
            dispatch(
                fetchLiveStreamRequest(
                    "?where=category:" + cat._id + ";owner:" + userProfile.id
                )
            );
        }
    }, [categories, userProfile]);

    let liveStreams = _.sortBy(allLiveStreams, (x) =>
        moment(x.dateUpdated).unix()
    ).reverse();

    let privateLounge = liveStreams.map((item) => {
        let duration = "00 : 00 : 00";
        if (
            item.durationTime &&
            item.streamingStatus.toLowerCase() !== "waiting"
        ) {
            let ms = item.durationTime * 1000;
            var d = moment.duration(ms);
            duration = `${d._data.hours
                .toString()
                .padStart(2, "0")} : ${d._data.minutes
                .toString()
                .padStart(2, "0")} : ${d._data.seconds
                .toString()
                .padStart(2, "0")}`;
        }
        return {
            id: item._id,
            img: hallImg,
            title: item.title,
            watch: item.totalWatch,
            comment: item.comments,
            date: moment(item.dateCreated).fromNow(),
            duration: duration,
            users: {
                owner: {
                    name: item.owner.fullName,
                    userName: item.owner.userName,
                    image: getImage(item.owner.attachments),
                },
                guests: item.guestInfo.map((x) => {
                    return {
                        name: x.fullName,
                        image: getImage(x.attachments),
                    };
                }),
            },
            streamUrl: item.streamUrl,
            attachments: item.attachments,
            streamingStatus: item.streamingStatus,
            s3Url: item.s3Url,
        };
    });

    return (
        <div className="">
            {userProfile.isSubscribe && (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {privateLounge.map((stream) => {
                        return (
                            <LiveStreamCard stream={stream} canDelete={false} />
                        );
                    })}
                </div>
            )}

            {!userProfile.isSubscribe && userPrivateLounge && (
                <Container maxWidth="md" className="my-4">
                    <Card elevation={0}>
                        <CardContent className="text-center my-2">
                            <Alert severity="info" className="my-2 text-danger">
                                Support and get access to{" "}
                                <b>{userProfile.fullName}</b> private lounge by
                                subscribing
                            </Alert>
                            <p className="text-center text-medium my-4">
                                {userPrivateLounge.description}
                            </p>

                            <Box
                                display="flex"
                                justifyContent="space-evenly"
                                className="my-4"
                            >
                                <p
                                    onClick={() => {
                                        setPeriod("Monthly");
                                    }}
                                    style={{
                                        color:
                                            period === "Monthly"
                                                ? "#0038FF"
                                                : "black",
                                        border:
                                            period === "Monthly"
                                                ? "1px solid #0038FF"
                                                : "1px solid #CECECE",
                                    }}
                                    className="text-medium text-center p-3 rounded-xl"
                                >
                                    {period === "Monthly" ? (
                                        <RadioButtonChecked />
                                    ) : (
                                        <RadioButtonUnchecked />
                                    )}
                                    <span className="text-bold text-large mx-2">
                                        {userPrivateLounge.currencySubscription +
                                            " " +
                                            userPrivateLounge.monthlySubscription}
                                    </span>
                                    / month
                                </p>
                                <p
                                    onClick={() => {
                                        setPeriod("Yearly");
                                    }}
                                    style={{
                                        color:
                                            period === "Yearly"
                                                ? "#0038FF"
                                                : "black",
                                        border:
                                            period === "Yearly"
                                                ? "1px solid #0038FF"
                                                : "1px solid #CECECE",
                                    }}
                                    className="text-medium text-center p-3 rounded-xl"
                                >
                                    {period === "Yearly" ? (
                                        <RadioButtonChecked />
                                    ) : (
                                        <RadioButtonUnchecked />
                                    )}
                                    <span className="text-bold text-large mx-2">
                                        {userPrivateLounge.currencySubscription +
                                            " " +
                                            userPrivateLounge.annuallySubscription}
                                    </span>
                                    / year
                                </p>
                            </Box>
                        </CardContent>
                        <CardActions className="text-center my-2">
                            <Box
                                display="flex"
                                width="100%"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    disabled={IsNullOrEmpty(period)}
                                    onClick={() => {
                                        dispatch(fetchPaymentConfigRequest());
                                        setTimeout(() => {
                                            navigate(
                                                "/page/subscription_payment",
                                                {
                                                    state: {
                                                        period: period,
                                                    },
                                                }
                                            );
                                        }, 2000);
                                    }}
                                >
                                    Subscribe Now
                                </Button>
                            </Box>
                        </CardActions>
                    </Card>
                </Container>
            )}

            {userProfile.isSubscribe && privateLounge.length === 0 && (
                <div className="flex flex-col items-center justify-start pt-9">
                    <p className="text-sm text-black-50 mb-5">
                        {userProfile.fullName} do not have any posts yet
                    </p>
                </div>
            )}

            {!userPrivateLounge && (
                <div className="flex flex-col items-center justify-start pt-9">
                    <p className="text-sm text-black-50 mb-5 text-center">
                        <span className="capitalize font-bold">
                            {userProfile.fullName}
                        </span>{" "}
                        not yet configured the subscription fees.
                        <br />
                        Please come again later.
                    </p>
                </div>
            )}
        </div>
    );
};

export default PrivateLounge;
